// Export for EnterpriseSwitcher
// FIXME: https://gitlab.ffit.lv/ff-it/init/-/issues/509
import type { NavItem } from 'components/nav';
import { menu as planning } from './Planning/menu';
import { menu as invoices } from './Invoices/menu';
import { menu as guarantee } from './Guarantee/menu';
import { menu as reporting } from './Reporting/menu';
import { menu as contacts } from './Contacts/menu';
import { menu as dashboard } from './Dashboard/menu';

import { menu as system } from '../_system/menu';
import { preferencesMenu } from './Preferences/menu';

export const menu: NavItem[] = [dashboard, planning, invoices, guarantee, reporting, contacts, preferencesMenu, system];
